import {
    BrowserAuthError,
    BrowserAuthErrorCodes,
    ClientAuthErrorCodes,
    InteractionRequiredAuthError,
} from '@azure/msal-browser-1p';
import type { AuthError } from '@azure/msal-browser-1p';
import { ClientAuthError } from '@azure/msal-common';

export function isInteractionRequiredOrNetworkError(error: AuthError): boolean {
    if (error instanceof InteractionRequiredAuthError) {
        return true;
    } else if (error instanceof BrowserAuthError || error instanceof ClientAuthError) {
        // we seem to be getting a lot of monitor_window_timeout errors in ssoSilent,
        // workaround with redirect for now until improvements are made to reduce these.
        // we need to perform interaction if ssoSilent fails with interaction required auth error or retriable errors (network errors)
        return (
            error.errorCode === BrowserAuthErrorCodes.monitorWindowTimeout ||
            error.errorCode === BrowserAuthErrorCodes.postRequestFailed ||
            error.errorCode === BrowserAuthErrorCodes.noNetworkConnectivity ||
            error.errorCode === ClientAuthErrorCodes.endpointResolutionError
        );
    }

    return false;
}
